import { themeQuartz } from "ag-grid-community";
import { defaultSettings } from "css/defaultAntStyles";
/**
 * DARK THEME
 */
export const myTheme = themeQuartz.withParams({
  backgroundColor: "#141414",
  foregroundColor: "#ffffff",

  headerBackgroundColor: "#1f1f1f",
  headerTextColor: "#ffffff",

  accentColor: defaultSettings.colorPrimary,

  borderColor: "rgba(255,255,255,0.08)",
  rowHoverColor: "rgba(250,84,28,0.08)",
  selectedRowBackgroundColor: "rgba(250,84,28,0.15)",

  fontFamily: "Inter, sans-serif",
  spacing: 8,
  borderRadius: 12,
});
